<template>
    <div class="col">
        <div class="row justify-content-center mt-3">
            <div class="col">
                <h3 class="text-center">Voting for adding attribute</h3>
                <p class="text-center">in {{detail.branch.name}}</p>
            </div>
        </div>

        <div class="row justify-content-center mt-3">
            <div class="col">
                <h3 class="text-center">Attribute</h3>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-6 text-right">Attribute Group:</div>
            <div class="col-6">{{detail.groupWithNewQuestion.name}}</div>
        </div>

        <app-property :property="detail.groupWithNewQuestion.properties[0]" class="mb-0" :isReadOnly="true"/>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import {QuestionVotingDetail} from "@/entities/voting/QuestionVotingDetail";
    import AppProperty from "@/components/questionnaire/AppProperty.vue";
    import AppGroup from "@/components/questionnaire/AppGroup.vue";

    @Component({
        components: {
            AppGroup,
            AppProperty,
        }
    })
    export default class QuestionVotingDetailView extends Vue{
        @Prop()
        detail!: QuestionVotingDetail;
    }
</script>

<style lang="scss" scoped>
</style>
